import Vue from 'vue'
import Vuex from 'vuex'
import ledger from './ledger'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    ledger
  }
})
